const transformVisionToTiptap = (vision, templateType = "recommended") => {
  if (!vision) {
    return { type: "doc", content: [], intention: "" };
  }

  let structureData = null;
  
  if (vision.structures && vision.structures[templateType]?.data) {
    structureData = vision.structures[templateType].data;
  } else {
    return { 
      type: "doc", 
      content: [], 
      intention: ""
    };
  }

  let intention = "";
  let contentArray = [];

  if (Array.isArray(structureData)) {
    contentArray = structureData;
  }if (Array.isArray(structureData?.content)) {
    intention = structureData.intention || structureData.title;
    contentArray = structureData.content;
  } 

  const transformedContent = transformContentArray(contentArray);

  const result = {
    type: "doc",
    content: transformedContent,
    intention: intention
  };

  return result;
};

const transformNodeRecursive = (node) => {
  if (!node) return null;

  if (!node.type) {
    return transformVisionCircleNode(node);
  }

  switch (node.type) {
    case "text":
      return transformParagraphNode(node.text || node.content);
    case "heading1":
    case "heading2":
    case "heading3":
    case "heading4":
    case "heading5":
    case "heading6":
      return transformHeadingNode(node);
    case "interactive-discussion":
      return transformIJNode(node);
    case "content":
    case "forum":
    case "calendar":
    case "events":
    case "showcase":
    case "discussion":
      return transformVisionCircleNode(node);
    case "startButton":
      return transformStartButtonNode(node);
    case "completeButton":
      return transformCompleteButtonNode(node);
    case "embed":
      return transformEmbedNode(node);
    case "grid1":
    case "grid2":
    case "grid3":
      return node;
    default:
      console.warn("Unknown node type:", node.type);
      return null;
  }
};

const getDefaultTitle = (nodeType) => {
  switch (nodeType) {
    case "forum":
      return "Forum";
    case "calendar":
      return "Event";
    case "events":
      return "Events";
    case "showcase":
      return "Showcase";
    case "discussion":
      return "Chat";
    default:
      return "Section";
  }
};

const transformContentArray = (contentArray) => {
  return Array.isArray(contentArray) ? contentArray.flatMap(node => {
    const result = transformNodeRecursive(node);
    const data = Array.isArray(result) ? result : [result];
    const emptyParagraph = ["text", "interactive-discussion", "startButton"].includes(node.type) ? [transformParagraphNode(" ")] : [];
    return [
      ...data,
      ...emptyParagraph
    ]
  }).filter(Boolean) : [];
};

const generateUid = () => {
  return Math.random().toString(36).substr(2, 9);
};

const transformHeadingNode = (node) => {
  let level = 1;
  
  switch (node.type) {
    case "heading1":
      level = 1;
      break;
    case "heading2":
      level = 2;
      break;
    case "heading3":
      level = 3;
      break;
    case "heading4":
      level = 4;
      break;
    case "heading5":
      level = 5;
      break;
    case "heading6":
      level = 6;
      break;
    default:
      level = 1;
  }

  return {
    type: "heading",
    attrs: {
      uid: generateUid(),
      level: level,
      textAlign: node.textAlign || "left"
    },
    content: [
      {
        type: "text",
        text: node.title || node.text || ""
      }
    ]
  };
};

const transformVisionCircleNode = (node) => {
  const transformedContent = transformContentArray(node.content);
  const hasDescription = typeof node?.metaDescription === "string" && node?.metaDescription?.length > 0;
  const hasImage = typeof node.image_url === "string" && node.image_url.length > 0;
  return {
    type: "visionCircle",
    attrs: {
      uid: generateUid(),
      title: node?.title || getDefaultTitle(node?.type),
      description: hasDescription ? node.metaDescription : null,
      circle_id: "CIRCLE_ID",
      viewAs: hasDescription && hasImage ? "hcard" : "list",
      version: node?.type,
      gallery_feature: hasImage ? { url: node.image_url } : null
    },
    content: transformedContent
  };
};

const transformIJNode = (node) => {
  const elements = [];

  if (typeof node.title === "string" && node.title.length > 0) {
    elements.push(transformHeadingNode({ type: "heading3", title: node.title }));
  }

  if (typeof node.description === "string" && node.description.length > 0) {
    elements.push(transformParagraphNode(node.description));
  }

  if (typeof node.video_url === "string" || typeof node.keywords === "string") {
    if (node.media_type && node.media_type === "video") {
      elements.push(transformVideoNode(node));
    }
  }

  if (typeof node.question === "string" && node.question.length > 0) {
    elements.push(transformParagraphNode(node.question));
  }

  elements.push({
    type: "visionInput",
    attrs: {
      uid: generateUid()
    }
  });

  return elements;
};

const transformParagraphNode = (text) => {
  return {
    type: "paragraph",
    attrs: {
      uid: generateUid(),
      textAlign: "left"
    },
    content: [
      {
        type: "text",
        text: text || " "
      }
    ]
  };
};

const transformStartButtonNode = (node) => {
  return {
    type: "interactiveButton",
    attrs: {
      uid: generateUid(),
      buttonText: node.title || "Let’s begin",
      interactivePosition: 0,
      textAlign: "center",
      radius: "circle-radius",
      class: "tiptap-size-actual"
    }
  };
};

const transformCompleteButtonNode = (node) => {
  return {
    type: "actionbutton",
    attrs: {
      uid: generateUid(),
      isMarkComplete: true,
      buttonText: "Mark complete",
      radius: "circle-radius",
      class: "tiptap-size-actual",
      idName: "actionbutton-node",
      textAlign: "center"
    }
  };
};

const transformEmbedNode = (node) => {

  return {
    type: "embed",
    attrs: {
      uid: generateUid(),
      // src: node.src,
      src: node.media_url || "https://www.youtube.com/embed/lIqJLpVfSQU?si=vLCJB3NV4ePIHCsY",
      title: node.title,
      videoId: node.video_id || "lIqJLpVfSQU",
      thumbnail_url: node.thumbnail_url,
      viewAs: "inline",
      controls: false,
      radius: "with-radius",
      resizeableHeight: "100%",
      resizeableWidth: "100%",
      resizeableParentHeight: "unset",
      textAlign: "center"
    }
  };
};

const transformVideoNode = (node) => {
  return {
    type: "video",
    attrs: {
      uid: generateUid(),
      src: node.media_url || "https://www.youtube.com/embed/lIqJLpVfSQU?si=vLCJB3NV4ePIHCsY",
      title: node.title,
      videoId: node.video_id || "lIqJLpVfSQU",
      thumbnail_url: node.thumbnail_url,
      viewAs: "inline",
      controls: false,
      radius: "with-radius",
      resizeableHeight: "100%",
      resizeableWidth: "100%",
      resizeableParentHeight: "unset",
      textAlign: "center"
    }
  };
};

const transformImageNode = (node) => {
  return {
    type: "image",
    attrs: {
      uid: generateUid(),
      src: node.image_url,
      // resizeableHeight: "100%",
      // resizeableWidth: "100%",
      // resizeableParentHeight: "unset",
      textAlign: "center"
    }
  };
};

export default transformVisionToTiptap;
